// extracted by mini-css-extract-plugin
export default {"primary_btn":"Button_primary_btn__AqE5e","search_btn":"Button_search_btn__r4QW1 Button_primary_btn__AqE5e","loadMore_btn":"Button_loadMore_btn__EVAOD Button_primary_btn__AqE5e"};